import {
  useCreateBlogPostMutation,
  useDeleteCaseStudyMutation,
  useGetBlogPostsQuery
} from 'src/redux/Api/caseStudiesApi'
import style from './style.module.scss'
import List from 'src/Components/List'
import { Link } from 'react-router'

const Blog = () => {
  const { data: caseStudies } = useGetBlogPostsQuery()
  const [createBlogPost] = useCreateBlogPostMutation()
  const [deleteCaseStudy] = useDeleteCaseStudyMutation()

  return (
    <>
      <List columns={['Name', 'Client', 'Path', 'Status', '*']} className={style.case_list}>
        {caseStudies &&
          caseStudies.length > 0 &&
          caseStudies.map((study, index) => (
            <li key={index} className={style.list_row}>
              <span>
                <Link to={`/site-admin/case-studies/${study.id}`}>{study.title}</Link>
              </span>
              <span>{study.client?.name}</span>
              <span>{study.url}</span>
              <span>{study.status}</span>
              <span>
                <button className="btn" onClick={() => deleteCaseStudy(study.id)}>
                  Delete
                </button>
              </span>
            </li>
          ))}
        {caseStudies && caseStudies.length === 0 && <li className={style.list_row}>No Case Studies Found</li>}
      </List>
      <button className="btn" onClick={() => createBlogPost()}>
        Add Case Study
      </button>
    </>
  )
}

export default Blog
